if (!customElements.get('mms-cwt-sticky')) {
  customElements.define('mms-cwt-sticky', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      this.variants = JSON.parse(this.querySelector('[data-cwt-variants]').textContent);
      this.add = this.querySelector('[data-cwt-add]');
      this.summary = this.querySelector('[data-cwt-summary]');
      this.reviews = this.querySelector('[data-cwt-reviews]');
      this.queue = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); }); };
      this.onAdd = () => {
        this.sync();
        const main = this.mainButton();
        if (main && !main.disabled && main.getAttribute('aria-disabled') !== 'true' && !main.classList.contains('loading')) main.click();
      };
      this.onReviews = () => {
        const original = this.ratingNode();
        const action = original?.querySelector('.vtl-pr-ss__inner-el') || original?.querySelector('a,button,[role="button"]') || original?.querySelector('.Vtl-pr-review-stars-snippet') || original;
        action?.click();
      };
      this.add.addEventListener('click', this.onAdd);
      this.reviews.addEventListener('click', this.onReviews);
      this.observe = new MutationObserver(records => { if (records.some(r => !this.contains(r.target) && !(r.target.nodeType === 1 ? r.target : r.target.parentElement)?.closest('[data-mms-oil-atc-price]'))) this.queue(); });
      this.observe.observe(this.root, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','class','value']});
      this.cartObserve = new MutationObserver(this.queue);
      document.querySelectorAll('cart-drawer,cart-notification,dialog,details-modal details,.menu-drawer-container').forEach(el => this.cartObserve.observe(el,{attributes:true,attributeFilter:['class','open']}));
      this.root.addEventListener('change', this.queue);
      this.root.addEventListener('input', this.queue);
      window.addEventListener('scroll',this.queue,{passive:true});
      window.addEventListener('resize',this.queue,{passive:true});
      window.visualViewport?.addEventListener('scroll',this.queue,{passive:true});
      window.visualViewport?.addEventListener('resize',this.queue,{passive:true});
      this.sync();
    }
    syncThumbnail(variant, summary) {
      const image = this.root.querySelector('[data-mms-sticky-image]');
      if (!image) return;
      const url = variant?.image || image.dataset.fallback || '';
      if (image.dataset.selectedSource !== url) {
        image.dataset.selectedSource = url;
        image.dataset.usedFallback = 'false';
        image.hidden = !url;
        image.onerror = () => {
          image.dataset.usedFallback = 'true';
          image.alt = (this.dataset.productTitle || '') + ' product image';
          const fallback = image.dataset.fallback;
          if (fallback && image.getAttribute('src') !== fallback) image.src = fallback;
          else image.hidden = true;
        };
        if (url) image.src = url;
      }
      image.alt = variant?.imageIsVariant && image.dataset.usedFallback !== 'true' ? [this.dataset.productTitle || '', summary || ''].filter(Boolean).join(' · ') : (this.dataset.productTitle || '') + ' product image';
    }
    mainButton() { return this.root?.querySelector(`#ProductSubmitButton-${this.dataset.section}`); }
    ratingNode() { return this.root?.querySelector('.product__title > .bundle-aggregated_reviews[data-track-mid="21"][data-track-eid="1"]'); }
    setText(el,text) { if (el.textContent !== text) el.textContent = text; }
    sync() {
      const main = this.mainButton();
      const rect = main?.getBoundingClientRect();
      const cartOpen = !!document.querySelector('cart-drawer.active,cart-drawer[open],cart-notification.active,dialog[open],details-modal details[open],.menu-drawer-container[open]');
      const hide = !rect || rect.height === 0 || rect.bottom > 0 || cartOpen;
      if (this.hidden !== hide) this.hidden = hide;
      const form = this.root?.querySelector(`#product-form-${this.dataset.section}`);
      if (!main || !form) return;
      const data = new FormData(form);
      const variant = this.variants.find(v => String(v.id) === String(data.get('id')));
      const planId = data.get('selling_plan');
      const plan = planId && variant?.plans.find(p => String(p.id) === String(planId));
      const cents = planId ? plan?.priceCents : variant?.priceCents;
      const rawQuantity = Number(data.get('quantity') || 1);
      const quantity = Number.isInteger(rawQuantity) && rawQuantity > 0 ? rawQuantity : null;
      const total = Number.isFinite(cents) && quantity ? new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.dataset.currency || 'USD'}).format(cents * quantity / 100) : '';
      const summary = (variant?.title || '') + (quantity > 1 ? ' · Qty ' + quantity : '');
      this.setText(this.summary, summary);
      this.syncThumbnail(variant, summary);
      const busy = main.disabled || main.getAttribute('aria-disabled') === 'true' || main.classList.contains('loading');
      this.add.disabled = busy;
      this.add.setAttribute('aria-busy',String(main.classList.contains('loading')));
      const nativeLabel = main.querySelector(':scope > span:not(.loading__spinner):not([data-mms-oil-atc-price])');
      const nativeText = Array.from(main.childNodes).filter(n => n.nodeType !== 1 || !n.matches('[data-mms-oil-atc-price],.loading__spinner')).map(n => n.textContent).join(' ');
      const label = (nativeLabel?.textContent || nativeText || 'Add to cart').trim().replace(/\s+/g,' ');
      let priceLabel = main.querySelector('[data-mms-oil-atc-price]');
      if (!priceLabel) {
        priceLabel = document.createElement('span');
        priceLabel.setAttribute('data-mms-oil-atc-price','');
        priceLabel.setAttribute('aria-live','polite');
        main.appendChild(priceLabel);
      }
      const purchaseLabel = /^(add to cart|pre[\s-]?order|reserve today)$/i.test(label) || label === window.variantStrings?.addToCart;
      const displayTotal = purchaseLabel ? total : '';
      this.setText(priceLabel,displayTotal ? '— ' + displayTotal : '');
      this.setText(this.add, (label || 'Add to cart') + (displayTotal ? ' — ' + displayTotal : ''));
      const rating = this.ratingNode()?.textContent.trim().replace(/\s+/g,' ');
      this.reviews.hidden = !rating;
      if (rating) this.setText(this.reviews,rating);
    }
    disconnectedCallback() {
      this.observe?.disconnect();this.cartObserve?.disconnect();
      window.visualViewport?.removeEventListener('scroll',this.queue);window.visualViewport?.removeEventListener('resize',this.queue);
      this.root?.removeEventListener('change',this.queue);
      this.root?.removeEventListener('input',this.queue);
      window.removeEventListener('scroll',this.queue);window.removeEventListener('resize',this.queue);
      this.add?.removeEventListener('click',this.onAdd);this.reviews?.removeEventListener('click',this.onReviews);
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}
